import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    image: {
        maxHeight: "40px",
        cursor: "pointer",
    }
}));

export default useStyles;